import * as React from 'react';
import { Layout, Space, Logo, Icon, Typography } from '@sravni/react-design-system';
import { Dzen, Odnoklassniki, Viber, VK, Telegram, Instagram, Facebook } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils/lib/hooks';
import modules_b21bc4dc from '../styles/Socials.module.less.js';
import { SocialLinkType } from '../types/Socials.types.js';

const { Link } = Typography;
const createIconBySocialItem = (item) => {
    const { text } = item;
    switch (text) {
        case SocialLinkType.FACEBOOK:
            return React.createElement(Facebook, null);
        case SocialLinkType.INSTAGRAM:
            return React.createElement(Instagram, null);
        case SocialLinkType.TELEGRAM:
            return React.createElement(Telegram, null);
        case SocialLinkType.VK:
            return React.createElement(VK, null);
        case SocialLinkType.VIBER:
            return React.createElement(Viber, null);
        case SocialLinkType.OK:
            return React.createElement(Odnoklassniki, null);
        case SocialLinkType.DZEN:
            return React.createElement(Dzen, null);
        default:
            return null;
    }
};
const filterByAvailableIcons = (socialLinks) => socialLinks.filter((item) => Object.values(SocialLinkType).includes(item.text));
/**
 * @description Logo with social links block of footer.
 *
 * @component
 * @example
 * ```jsx
 * <Socials />
 * ```
 */
const LogoElement = () => {
    const cx = useStyles(modules_b21bc4dc);
    return (React.createElement("a", { href: "/", className: cx('socials-logo'), "aria-label": '\u041B\u043E\u0433\u043E\u0442\u0438\u043F' },
        React.createElement(Logo, null)));
};
const SocialList = (props) => {
    const { socialLinks } = props;
    const clearSocialLinks = filterByAvailableIcons(socialLinks);
    const cx = useStyles(modules_b21bc4dc);
    return (React.createElement(React.Fragment, null, clearSocialLinks.map((social) => {
        const IconSocial = createIconBySocialItem(social);
        const { href, noindex, nofollow, openInNew } = social;
        const rel = ['noopener', 'noreferrer', noindex ? 'noindex' : false, nofollow ? 'nofollow' : false];
        if (!IconSocial)
            return null;
        return (React.createElement(Link, { className: cx('socials-link'), key: href, color: "gray", href: href, target: openInNew ? '_blank' : '_self', rel: rel.filter(Boolean).join(' '), "aria-label": social.text },
            React.createElement(Icon, { icon: IconSocial })));
    })));
};
const Socials = React.forwardRef((props, ref) => {
    const { className, socialLinks, ...restProps } = props;
    const cx = useStyles(modules_b21bc4dc);
    return (React.createElement(Layout, { ref: ref, className: cx(className, 'container', 'socials-block'), ...restProps },
        React.createElement(Space, { justify: "space-between", align: "center" },
            React.createElement(LogoElement, null),
            React.createElement(Space, { size: 20, justify: "space-between", className: cx('socials-icons') },
                React.createElement(SocialList, { socialLinks: socialLinks })))));
});

export { Socials as default };
//# sourceMappingURL=Socials.js.map
